import { takeLatest, put, call } from "redux-saga/effects";
import LoginTypes from "./LoginActionTypes";
import { getAMCResponse, postLoginResponse } from "./LoginActions";
import { axiosGet, axiosPost, setAuthToken } from "../../Utils/axios";
import axios from "axios";

export function* onPostLoginSaga({ payload }) {
  try {
    let response = yield call(() =>
      axiosPost("auth/login", payload).then((res) => res?.data)
    );
    if (response?.success) {
      localStorage.setItem("token", response?.data.token);
      setAuthToken(response?.data.token);
    }
    yield put(postLoginResponse(response));
  } catch (error) {
    yield put(postLoginResponse(error));
  }
}

export function* onGetAMCSaga({ payload }) {
  try {
    let response = yield call(() =>
      axios
        .get(
          `${
            process.env.REACT_APP_CRM_DOMAIN ||
            "https://api.crm-sass.gwayerp.in"
          }/amc_reminder/${
            process.env.REACT_APP_CRM_PROJECT_ID || "GWAY-PR-001"
          }`,
          payload
        )
        .then((res) => res?.data)
    );
    yield put(getAMCResponse(response));
  } catch (error) {
    console.log(error, "ERROR WHILE GET AMC REMINDER");
  }
}

//WATCHER
export function* LoginWatcherSaga() {
  yield takeLatest(LoginTypes.POST_LOGIN_REQUEST, onPostLoginSaga);
  yield takeLatest(LoginTypes.GET_AMC_REMINDERS_REQUEST, onGetAMCSaga);
}
